import React from "react";
import { Link } from "react-router-dom";
import "../assets/css/navbar.css";
import { X } from "lucide-react";
import nav_logo from "../assets/images/logoNexatrux-lg-white-trans.png";

/*
 there's a drop down menu created down but it has been 
 commented out because we felt it wasn't necessary currently
 who ever the programmer in the future will be, just uncomment the 
 minibar class and miniNav state and import useState and cheronDown
 the stylng is in the ../assets/css/navbar.css".  
*/
const Navbar = ({ showNav, setShowNav, isScrolled }) => {
  // const [miniNav, setMiniNav] = useState(false);
  // const toggleMiniNav = () => {
  //   setMiniNav(!miniNav);
  // };

  return (
    <div>
      <nav className={`nav-bar ${showNav ? "left" : ""}`}>
        <div className={`nav-column ${showNav ? "left" : ""}`}>
          <a href="https://www.nexatrux.com/">
            <img
              src={nav_logo}
              style={showNav ? { display: "block" } : { display: "none" }}
              width="100"
              alt="logo transparent"
            />
          </a>
          <ul className="nav-menu">
            {/* <li className="nav-list">
              <Link onClick={() => setShowNav(false)} to="/about">
                About
              </Link>
            </li> */}
            <li className="nav-list showBootcamp ">
              <div className={`mini-nav ${isScrolled ? "link-color" : ""}`}>
                <Link onClick={() => setShowNav(false)} to="/bootcamp">
                  Bootcamp Events
                </Link>
                {/* <span
                  className={`${miniNav ? "rotate" : ""}`}
                  onClick={toggleMiniNav}
                >
                  <ChevronDown />
                </span> */}
              </div>
              {/* <div className="bootcamp">
                <ul
                  className={`bootcamp-detail ${
                    miniNav === false ? "" : "display"
                  }`}
                >
                  <li className="nav-list list">
                    <Link  onClick={() => setShowNav(false)} to="/previous">Previous Bootcamp</Link>
                  </li>
                  <li className="nav-list list">
                    <Link  onClick={() => setShowNav(false)} to="/previous">UpComing Bootcamp</Link>
                  </li>
                </ul>
              </div> */}
            </li>
            <li className={`nav-list ${isScrolled ? "link-color" : ""} `}>
              <Link onClick={() => setShowNav(false)} to="/contact">
                contact
              </Link>
            </li>
          </ul>
        </div>
        <span
          className="close-bg"
          style={showNav ? { display: "block" } : { display: "none" }}
          onClick={() => setShowNav(false)}
        >
          <X />
        </span>
      </nav>
    </div>
  );
};

export default Navbar;
